export default "__VITE_ASSET__DkEC80Nv__"